/**
 * Turn a human-readable app name into a safe filename segment (ASCII, kebab-case).
 * @param {string} value
 * @returns {string} slug or empty string if nothing usable remains
 */
export function slugifyForFilename(value) {
  if (typeof value !== 'string') {
    return ''
  }

  const trimmed = value.trim()
  if (!trimmed) {
    return ''
  }

  const ascii = trimmed
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80)

  return ascii || ''
}
